import React from 'react';

import { BlankDSPItemWrapper } from '../../DSPSelector.style';

const BlankDSPItem: React.FC<{ childNumber: number }> = ({ childNumber }) => (
  <BlankDSPItemWrapper>{childNumber}</BlankDSPItemWrapper>
);

export default BlankDSPItem;
